import { Link } from 'react-router-dom'
import styled from 'styled-components'

import media from 'utils/media'
import { isWhiteLabel } from 'utils/whiteLabel'

export const HeaderContainer = styled.header`
  position: ${(props) => (props.isFixed ? 'fixed' : 'relative')};
  z-index: ${(props) => (props.isFixed ? 1 : 'auto')};
  top: 0;
  left: 0;
  width: 100%;
  padding-left: 40px;
  padding-right: 40px;
  /* The whitelabel venue logo splits the 20px top padding evenly above and
     below it, so it sits in the middle of the white bar above the grey review
     and status pages, and the header keeps its height. */
  padding-top: ${(props) => (props.hasVenueLogo ? '10px' : '20px')};
  padding-bottom: ${(props) => (props.hasVenueLogo ? '10px' : '0')};
  background-color: ${(props) => props.theme.colors.white};
  display: block;
  background: #ffffff;

  ${media.screen`
    padding: 15px 15px 0px;
    display: ${(props) => (props.isOrderPage ? 'none' : 'block')};    
  `};
`

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: ${(p) => (p.centered ? 'center' : 'self-start')};
  height: 60px;

  & #dummy-profile {
    display: none;
  }

  .dummy-authed & #dummy-profile {
    display: block;
  }

  .dummy-authed & #dummy-profile + * {
    display: none;
  }
`

export const Logo = styled.img`
  cursor: pointer;
  width: 70px;
  height: 48px;
  ${media.desktop`
    width: 51px;
    height: 35px;
  `};
`

export const RightSection = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-left: auto;
  order: 2;

  gap: 12px;
`

export const RegisterVenue = styled.button`
  background: #fdf0e9;
  border-radius: 8px;

  height: 40px;
  border-radius: 8px;

  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;

  text-align: center;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  color: #f26722;
  padding-left: 20px;
  padding-right: 20px;
  outline: none !important;
`

export const CorporateButton = styled.button`
  background: #fdf0e9;
  border-radius: 8px;

  height: 40px;
  border-radius: 8px;

  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;

  text-align: center;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  color: #f26722;
  padding-left: 20px;
  padding-right: 20px;
  outline: none !important;
`

export const LoginButton = styled.button`
  height: 40px;

  background: ${isWhiteLabel() ? '#000' : '#fdf0e9'};
  border-radius: 8px;

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 12px 20px 10px;

  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;

  text-align: center;

  color: ${isWhiteLabel() ? '#FFF' : '#f26722'};
`

export const IconContainer = styled.div`
  display: inline;
`

export const Notif = styled.div`
  width: 20px;
  height: 20px;
  background: #f26722;
  border-radius: 25px;
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;

  text-align: center;
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0em;

  color: white;

  position: relative;
  top: -18px;
  left: 20px;
`

export const IconBox = styled.button`
  width: 40px;
  height: 40px;

  background: #fdf0e9;
  border-radius: 8px;

  display: flex;
  align-items: center;
  justify-content: center;
`

export const OrderPartyHeader = styled.div`
  height: 60px;
  width: 100%;
  margin: 0 auto;
  background: #000000;
  padding: 18px 0px;

  color: #fff;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;

  ${media.screen`
    display:none;
  `}
`

export const VenueLogo = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  overflow: hidden;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  & > .logo {
    width: 100%;
    height: 100%;
    background: url(${(p) => p.src}) lightgray 50% / cover no-repeat;
  }
`

export const BackButton = styled(Link)`
  height: 40px;
  gap: 20px;
  outline: none;
  text-decoration: none;
`
